"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_DONATION_FAILURE = exports.DELETE_DONATION_SUCCESS = exports.DELETE_DONATION_REQUEST = exports.EDIT_DONATION_FAILURE = exports.EDIT_DONATION_SUCCESS = exports.EDIT_DONATION_REQUEST = exports.ADD_DONATION_FAILURE = exports.ADD_DONATION_SUCCESS = exports.ADD_DONATION_REQUEST = exports.INVALID_DIRECTOR_UPLOAD_DURATION = exports.RESET_DIRECTOR_VIDEO_UPLOAD = exports.SET_UPLOAD_THUMBNAIL = exports.SET_UPLOAD_PROGRESS = exports.SET_UPLOAD_IN_PROGRESS = exports.SELECT_DIRECTOR_VIDEO_FAILURE = exports.SELECT_DIRECTOR_VIDEO_SUCCESS = exports.SELECT_DIRECTOR_VIDEO_REQUEST = exports.DELETE_INVITE_FAILURE = exports.DELETE_INVITE_SUCCESS = exports.DELETE_INVITE_REQUEST = exports.EDIT_THEME_FAILURE = exports.EDIT_THEME_SUCCESS = exports.EDIT_THEME_REQUEST = exports.EDIT_FUNERAL_INFO_RESET = exports.EDIT_FUNERAL_INFO_FAILURE = exports.EDIT_FUNERAL_INFO_SUCCESS = exports.EDIT_FUNERAL_INFO_REQUEST = exports.EDIT_OBITUARY_FAILURE = exports.EDIT_OBITUARY_SUCCESS = exports.EDIT_OBITUARY_REQUEST = exports.ADD_OBITUARY_FAILURE = exports.ADD_OBITUARY_SUCCESS = exports.ADD_OBITUARY_REQUEST = exports.ADD_NOSERVICE_OPTIONS_FAILURE = exports.ADD_NOSERVICE_OPTIONS_SUCCESS = exports.ADD_NOSERVICE_OPTIONS_REQUEST = exports.DELETE_SERVICE_FAILURE = exports.DELETE_SERVICE_SUCCESS = exports.DELETE_SERVICE_REQUEST = exports.GET_LOCATIONS_FAILURE = exports.GET_LOCATIONS_SUCCESS = exports.GET_LOCATIONS_REQUEST = exports.EDIT_SERVICE_FAILURE = exports.EDIT_SERVICE_SUCCESS = exports.EDIT_SERVICE_REQUEST = exports.ADD_NEW_SERVICE_FAILURE = exports.ADD_NEW_SERVICE_SUCCESS = exports.ADD_NEW_SERVICE_REQUEST = exports.RESET_DUPE_ACCESSOR_ERROR = exports.DELETE_ACCESSOR_FAILURE = exports.DELETE_ACCESSOR_SUCCESS = exports.DELETE_ACCESSOR_REQUEST = exports.EDIT_ACCESSOR_FAILURE = exports.EDIT_ACCESSOR_SUCCESS = exports.EDIT_ACCESSOR_REQUEST = exports.ADD_NEW_ACCESSOR_FAILURE = exports.ADD_NEW_ACCESSOR_SUCCESS = exports.ADD_NEW_ACCESSOR_REQUEST = exports.EDIT_DECEDENT_PHONE_SUCCESS = exports.EDIT_DECEDENT_PHONE_FAILURE = exports.EDIT_DECEDENT_PHONE_REQUEST = exports.EDIT_DECEDENT_DETAILS_FAILURE = exports.EDIT_DECEDENT_DETAILS_SUCCESS = exports.EDIT_DECEDENT_DETAILS_REQUEST = exports.SEND_MEMORIAL_LINK_RESET = exports.SEND_MEMORIAL_LINK_FAILURE = exports.SEND_MEMORIAL_LINK_SUCCESS = exports.SEND_MEMORIAL_LINK_REQUEST = exports.INVITE_SENT_RESET = exports.FINISH_INVITE_CREATION_FAILURE = exports.FINISH_INVITE_CREATION_SUCCESS = exports.FINISH_INVITE_CREATION_REQUEST = exports.FETCH_UNFINISHED_INVITE_FAILURE = exports.FETCH_UNFINISHED_INVITE_SUCCESS = exports.FETCH_UNFINISHED_INVITE_REQUEST = exports.START_INVITE_CREATION_FAILURE = exports.START_INVITE_CREATION_SUCCESS = exports.START_INVITE_CREATION_REQUEST = exports.RESET_INVITE_CREATION = void 0;
// Reset
var RESET_INVITE_CREATION = 'RESET_INVITE_CREATION'; // Creation

exports.RESET_INVITE_CREATION = RESET_INVITE_CREATION;
var START_INVITE_CREATION_REQUEST = 'START_INVITE_CREATION_REQUEST';
exports.START_INVITE_CREATION_REQUEST = START_INVITE_CREATION_REQUEST;
var START_INVITE_CREATION_SUCCESS = 'START_INVITE_CREATION_SUCCESS';
exports.START_INVITE_CREATION_SUCCESS = START_INVITE_CREATION_SUCCESS;
var START_INVITE_CREATION_FAILURE = 'START_INVITE_CREATION_FAILURE';
exports.START_INVITE_CREATION_FAILURE = START_INVITE_CREATION_FAILURE;
var FETCH_UNFINISHED_INVITE_REQUEST = 'FETCH_UNFINISHED_INVITE_REQUEST';
exports.FETCH_UNFINISHED_INVITE_REQUEST = FETCH_UNFINISHED_INVITE_REQUEST;
var FETCH_UNFINISHED_INVITE_SUCCESS = 'FETCH_UNFINISHED_INVITE_SUCCESS';
exports.FETCH_UNFINISHED_INVITE_SUCCESS = FETCH_UNFINISHED_INVITE_SUCCESS;
var FETCH_UNFINISHED_INVITE_FAILURE = 'FETCH_UNFINISHED_INVITE_FAILURE';
exports.FETCH_UNFINISHED_INVITE_FAILURE = FETCH_UNFINISHED_INVITE_FAILURE;
var FINISH_INVITE_CREATION_REQUEST = 'FINISH_INVITE_CREATION_REQUEST';
exports.FINISH_INVITE_CREATION_REQUEST = FINISH_INVITE_CREATION_REQUEST;
var FINISH_INVITE_CREATION_SUCCESS = 'FINISH_INVITE_CREATION_SUCCESS';
exports.FINISH_INVITE_CREATION_SUCCESS = FINISH_INVITE_CREATION_SUCCESS;
var FINISH_INVITE_CREATION_FAILURE = 'FINISH_INVITE_CREATION_FAILURE';
exports.FINISH_INVITE_CREATION_FAILURE = FINISH_INVITE_CREATION_FAILURE;
var INVITE_SENT_RESET = 'INVITE_SENT_RESET';
exports.INVITE_SENT_RESET = INVITE_SENT_RESET;
var SEND_MEMORIAL_LINK_REQUEST = 'SEND_MEMORIAL_LINK_REQUEST';
exports.SEND_MEMORIAL_LINK_REQUEST = SEND_MEMORIAL_LINK_REQUEST;
var SEND_MEMORIAL_LINK_SUCCESS = 'SEND_MEMORIAL_LINK_SUCCESS';
exports.SEND_MEMORIAL_LINK_SUCCESS = SEND_MEMORIAL_LINK_SUCCESS;
var SEND_MEMORIAL_LINK_FAILURE = 'SEND_MEMORIAL_LINK_FAILURE';
exports.SEND_MEMORIAL_LINK_FAILURE = SEND_MEMORIAL_LINK_FAILURE;
var SEND_MEMORIAL_LINK_RESET = 'SEND_MEMORIAL_LINK_RESET'; // Decedent Details

exports.SEND_MEMORIAL_LINK_RESET = SEND_MEMORIAL_LINK_RESET;
var EDIT_DECEDENT_DETAILS_REQUEST = 'EDIT_DECEDENT_DETAILS_REQUEST';
exports.EDIT_DECEDENT_DETAILS_REQUEST = EDIT_DECEDENT_DETAILS_REQUEST;
var EDIT_DECEDENT_DETAILS_SUCCESS = 'EDIT_DECEDENT_DETAILS_SUCCESS';
exports.EDIT_DECEDENT_DETAILS_SUCCESS = EDIT_DECEDENT_DETAILS_SUCCESS;
var EDIT_DECEDENT_DETAILS_FAILURE = 'EDIT_DECEDENT_DETAILS_FAILURE';
exports.EDIT_DECEDENT_DETAILS_FAILURE = EDIT_DECEDENT_DETAILS_FAILURE;
var EDIT_DECEDENT_PHONE_REQUEST = 'EDIT_DECEDENT_PHONE_REQUEST';
exports.EDIT_DECEDENT_PHONE_REQUEST = EDIT_DECEDENT_PHONE_REQUEST;
var EDIT_DECEDENT_PHONE_FAILURE = 'EDIT_DECEDENT_PHONE_FAILURE';
exports.EDIT_DECEDENT_PHONE_FAILURE = EDIT_DECEDENT_PHONE_FAILURE;
var EDIT_DECEDENT_PHONE_SUCCESS = 'EDIT_DECEDENT_PHONE_SUCCESS'; // Accessors

exports.EDIT_DECEDENT_PHONE_SUCCESS = EDIT_DECEDENT_PHONE_SUCCESS;
var ADD_NEW_ACCESSOR_REQUEST = 'ADD_NEW_ACCESSOR_REQUEST';
exports.ADD_NEW_ACCESSOR_REQUEST = ADD_NEW_ACCESSOR_REQUEST;
var ADD_NEW_ACCESSOR_SUCCESS = 'ADD_NEW_ACCESSOR_SUCCESS';
exports.ADD_NEW_ACCESSOR_SUCCESS = ADD_NEW_ACCESSOR_SUCCESS;
var ADD_NEW_ACCESSOR_FAILURE = 'ADD_NEW_ACCESSOR_FAILURE';
exports.ADD_NEW_ACCESSOR_FAILURE = ADD_NEW_ACCESSOR_FAILURE;
var EDIT_ACCESSOR_REQUEST = 'EDIT_ACCESSOR_REQUEST';
exports.EDIT_ACCESSOR_REQUEST = EDIT_ACCESSOR_REQUEST;
var EDIT_ACCESSOR_SUCCESS = 'EDIT_ACCESSOR_SUCCESS';
exports.EDIT_ACCESSOR_SUCCESS = EDIT_ACCESSOR_SUCCESS;
var EDIT_ACCESSOR_FAILURE = 'EDIT_ACCESSOR_FAILURE';
exports.EDIT_ACCESSOR_FAILURE = EDIT_ACCESSOR_FAILURE;
var DELETE_ACCESSOR_REQUEST = 'DELETE_ACCESSOR_REQUEST';
exports.DELETE_ACCESSOR_REQUEST = DELETE_ACCESSOR_REQUEST;
var DELETE_ACCESSOR_SUCCESS = 'DELETE_ACCESSOR_SUCCESS';
exports.DELETE_ACCESSOR_SUCCESS = DELETE_ACCESSOR_SUCCESS;
var DELETE_ACCESSOR_FAILURE = 'DELETE_ACCESSOR_FAILURE';
exports.DELETE_ACCESSOR_FAILURE = DELETE_ACCESSOR_FAILURE;
var RESET_DUPE_ACCESSOR_ERROR = 'RESET_DUPE_ACCESSOR_ERROR'; // Services

exports.RESET_DUPE_ACCESSOR_ERROR = RESET_DUPE_ACCESSOR_ERROR;
var ADD_NEW_SERVICE_REQUEST = 'ADD_NEW_SERVICE_REQUEST';
exports.ADD_NEW_SERVICE_REQUEST = ADD_NEW_SERVICE_REQUEST;
var ADD_NEW_SERVICE_SUCCESS = 'ADD_NEW_SERVICE_SUCCESS';
exports.ADD_NEW_SERVICE_SUCCESS = ADD_NEW_SERVICE_SUCCESS;
var ADD_NEW_SERVICE_FAILURE = 'ADD_NEW_SERVICE_FAILURE';
exports.ADD_NEW_SERVICE_FAILURE = ADD_NEW_SERVICE_FAILURE;
var EDIT_SERVICE_REQUEST = 'EDIT_SERVICE_REQUEST';
exports.EDIT_SERVICE_REQUEST = EDIT_SERVICE_REQUEST;
var EDIT_SERVICE_SUCCESS = 'EDIT_SERVICE_SUCCESS';
exports.EDIT_SERVICE_SUCCESS = EDIT_SERVICE_SUCCESS;
var EDIT_SERVICE_FAILURE = 'EDIT_SERVICE_FAILURE';
exports.EDIT_SERVICE_FAILURE = EDIT_SERVICE_FAILURE;
var GET_LOCATIONS_REQUEST = 'GET_LOCATIONS_REQUEST';
exports.GET_LOCATIONS_REQUEST = GET_LOCATIONS_REQUEST;
var GET_LOCATIONS_SUCCESS = 'GET_LOCATIONS_SUCCESS';
exports.GET_LOCATIONS_SUCCESS = GET_LOCATIONS_SUCCESS;
var GET_LOCATIONS_FAILURE = 'GET_LOCATIONS_FAILURE';
exports.GET_LOCATIONS_FAILURE = GET_LOCATIONS_FAILURE;
var DELETE_SERVICE_REQUEST = 'DELETE_SERVICE_REQUEST';
exports.DELETE_SERVICE_REQUEST = DELETE_SERVICE_REQUEST;
var DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS';
exports.DELETE_SERVICE_SUCCESS = DELETE_SERVICE_SUCCESS;
var DELETE_SERVICE_FAILURE = 'DELETE_SERVICE_FAILURE';
exports.DELETE_SERVICE_FAILURE = DELETE_SERVICE_FAILURE;
var ADD_NOSERVICE_OPTIONS_REQUEST = 'ADD_NOSERVICE_OPTIONS_REQUEST';
exports.ADD_NOSERVICE_OPTIONS_REQUEST = ADD_NOSERVICE_OPTIONS_REQUEST;
var ADD_NOSERVICE_OPTIONS_SUCCESS = 'ADD_NOSERVICE_OPTIONS_SUCCESS';
exports.ADD_NOSERVICE_OPTIONS_SUCCESS = ADD_NOSERVICE_OPTIONS_SUCCESS;
var ADD_NOSERVICE_OPTIONS_FAILURE = 'ADD_NOSERVICE_OPTIONS_FAILURE'; // Obituary

exports.ADD_NOSERVICE_OPTIONS_FAILURE = ADD_NOSERVICE_OPTIONS_FAILURE;
var ADD_OBITUARY_REQUEST = 'ADD_OBITUARY_REQUEST';
exports.ADD_OBITUARY_REQUEST = ADD_OBITUARY_REQUEST;
var ADD_OBITUARY_SUCCESS = 'ADD_OBITUARY_SUCCESS';
exports.ADD_OBITUARY_SUCCESS = ADD_OBITUARY_SUCCESS;
var ADD_OBITUARY_FAILURE = 'ADD_OBITUARY_FAILURE';
exports.ADD_OBITUARY_FAILURE = ADD_OBITUARY_FAILURE;
var EDIT_OBITUARY_REQUEST = 'EDIT_OBITUARY_REQUEST';
exports.EDIT_OBITUARY_REQUEST = EDIT_OBITUARY_REQUEST;
var EDIT_OBITUARY_SUCCESS = 'EDIT_OBITUARY_SUCCESS';
exports.EDIT_OBITUARY_SUCCESS = EDIT_OBITUARY_SUCCESS;
var EDIT_OBITUARY_FAILURE = 'EDIT_OBITUARY_FAILURE'; // Funeral Info

exports.EDIT_OBITUARY_FAILURE = EDIT_OBITUARY_FAILURE;
var EDIT_FUNERAL_INFO_REQUEST = 'EDIT_FUNERAL_INFO_REQUEST';
exports.EDIT_FUNERAL_INFO_REQUEST = EDIT_FUNERAL_INFO_REQUEST;
var EDIT_FUNERAL_INFO_SUCCESS = 'EDIT_FUNERAL_INFO_SUCCESS';
exports.EDIT_FUNERAL_INFO_SUCCESS = EDIT_FUNERAL_INFO_SUCCESS;
var EDIT_FUNERAL_INFO_FAILURE = 'EDIT_FUNERAL_INFO_FAILURE';
exports.EDIT_FUNERAL_INFO_FAILURE = EDIT_FUNERAL_INFO_FAILURE;
var EDIT_FUNERAL_INFO_RESET = 'EDIT_FUNERAL_INFO_RESET'; // Theme

exports.EDIT_FUNERAL_INFO_RESET = EDIT_FUNERAL_INFO_RESET;
var EDIT_THEME_REQUEST = 'EDIT_THEME_REQUEST';
exports.EDIT_THEME_REQUEST = EDIT_THEME_REQUEST;
var EDIT_THEME_SUCCESS = 'EDIT_THEME_SUCCESS';
exports.EDIT_THEME_SUCCESS = EDIT_THEME_SUCCESS;
var EDIT_THEME_FAILURE = 'EDIT_THEME_FAILURE'; // Delete

exports.EDIT_THEME_FAILURE = EDIT_THEME_FAILURE;
var DELETE_INVITE_REQUEST = 'DELETE_INVITE_REQUEST';
exports.DELETE_INVITE_REQUEST = DELETE_INVITE_REQUEST;
var DELETE_INVITE_SUCCESS = 'DELETE_INVITE_SUCCESS';
exports.DELETE_INVITE_SUCCESS = DELETE_INVITE_SUCCESS;
var DELETE_INVITE_FAILURE = 'DELETE_INVITE_FAILURE'; // Director Video

exports.DELETE_INVITE_FAILURE = DELETE_INVITE_FAILURE;
var SELECT_DIRECTOR_VIDEO_REQUEST = 'SELECT_DIRECTOR_VIDEO_REQUEST';
exports.SELECT_DIRECTOR_VIDEO_REQUEST = SELECT_DIRECTOR_VIDEO_REQUEST;
var SELECT_DIRECTOR_VIDEO_SUCCESS = 'SELECT_DIRECTOR_VIDEO_SUCCESS';
exports.SELECT_DIRECTOR_VIDEO_SUCCESS = SELECT_DIRECTOR_VIDEO_SUCCESS;
var SELECT_DIRECTOR_VIDEO_FAILURE = 'SELECT_DIRECTOR_VIDEO_FAILURE'; // Upload Director Video

exports.SELECT_DIRECTOR_VIDEO_FAILURE = SELECT_DIRECTOR_VIDEO_FAILURE;
var SET_UPLOAD_IN_PROGRESS = 'SET_UPLOAD_IN_PROGRESS';
exports.SET_UPLOAD_IN_PROGRESS = SET_UPLOAD_IN_PROGRESS;
var SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS';
exports.SET_UPLOAD_PROGRESS = SET_UPLOAD_PROGRESS;
var SET_UPLOAD_THUMBNAIL = 'SET_UPLOAD_THUMBNAIL';
exports.SET_UPLOAD_THUMBNAIL = SET_UPLOAD_THUMBNAIL;
var RESET_DIRECTOR_VIDEO_UPLOAD = 'RESET_DIRECTOR_VIDEO_UPLOAD';
exports.RESET_DIRECTOR_VIDEO_UPLOAD = RESET_DIRECTOR_VIDEO_UPLOAD;
var INVALID_DIRECTOR_UPLOAD_DURATION = 'INVALID_DIRECTOR_UPLOAD_DURATION'; //Donation

exports.INVALID_DIRECTOR_UPLOAD_DURATION = INVALID_DIRECTOR_UPLOAD_DURATION;
var ADD_DONATION_REQUEST = 'ADD_DONATION_REQUEST';
exports.ADD_DONATION_REQUEST = ADD_DONATION_REQUEST;
var ADD_DONATION_SUCCESS = 'ADD_DONATION_SUCCESS';
exports.ADD_DONATION_SUCCESS = ADD_DONATION_SUCCESS;
var ADD_DONATION_FAILURE = 'ADD_DONATION_FAILURE';
exports.ADD_DONATION_FAILURE = ADD_DONATION_FAILURE;
var EDIT_DONATION_REQUEST = 'EDIT_DONATION_REQUEST';
exports.EDIT_DONATION_REQUEST = EDIT_DONATION_REQUEST;
var EDIT_DONATION_SUCCESS = 'EDIT_DONATION_SUCCESS';
exports.EDIT_DONATION_SUCCESS = EDIT_DONATION_SUCCESS;
var EDIT_DONATION_FAILURE = 'EDIT_DONATION_FAILURE';
exports.EDIT_DONATION_FAILURE = EDIT_DONATION_FAILURE;
var DELETE_DONATION_REQUEST = 'DELETE_DONATION_REQUEST';
exports.DELETE_DONATION_REQUEST = DELETE_DONATION_REQUEST;
var DELETE_DONATION_SUCCESS = 'DELETE_DONATION_SUCCESS';
exports.DELETE_DONATION_SUCCESS = DELETE_DONATION_SUCCESS;
var DELETE_DONATION_FAILURE = 'DELETE_DONATION_FAILURE';
exports.DELETE_DONATION_FAILURE = DELETE_DONATION_FAILURE;